import { booleanAttribute, Directive, ElementRef, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DestroyService } from '@services/destroy.service';
import { DeviceDetectService } from '@services/device-detect.service';
import { delay, filter, fromEvent, takeUntil } from 'rxjs';

@Directive({
    selector: '[pnFocusIntoView]',
    standalone: true,
    providers: [DestroyService],
})
export class FocusIntoViewDirective {
    private _el = inject(ElementRef<HTMLElement>);
    private _destroy$ = inject(DestroyService);
    private _device = inject(DeviceDetectService);

    private readonly _isMobile = toSignal(this._device.isMobile());
    @Input({ transform: booleanAttribute }) appFocusIntoView = this._isMobile();

    constructor() {
        this._el.nativeElement && this.appFocusIntoView && this._scrollIntoView();
    }

    /**
     * Scroll the element into view when it receives focus.
     *
     * @private
     * @memberof FocusIntoViewDirective
     */
    private _scrollIntoView() {
        fromEvent(this._el.nativeElement, 'focus')
            .pipe(
                delay(200),
                filter(() => !!this.appFocusIntoView),
                takeUntil(this._destroy$)
            )
            .subscribe(() => {
                this._el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
    }
}
